import React,{ useContext, useEffect } from "react";
import Section1 from "../components/Section1";
import OurStory from "../components/OurStory";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import Aos from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import ReactGA from "react-ga";
import { TeamContext } from "../Contexts/TeamContext";

ReactGA.pageview(window.location.pathname + window.location.search);

const SawaPage = () => {
  const { fetchTeam } = useContext(TeamContext);
  useEffect(() => {
    Aos.init({ duration: 100 });
    fetchTeam();
  }, []);
  return (
    <>
      <Helmet>
        <title>SAWA | About Us</title>
        <meta name="description" content="" />
        <link rel="canonical" href="/about-sawa" />
      </Helmet>
      <NavBar />
      <Section1 />
      <OurStory />
      <Footer />
    </>
  );
};

export default SawaPage;
